import React from 'react';
import RelatedEmails from 'components/RelatedEmails';

/**
 * Üretim e-posta sayfası
 * Tüm fonksiyonalite RelatedEmails componentine taşındı
 *
 * @param {Object} props - Component props
 * @param {Object} props.production - Üretim verisi
 * @returns {JSX.Element}
 */
const EmailPage = ({ production }) => {
    return <RelatedEmails entity={production} entityType="production" title="Üretim E-postaları" />;
};

export default EmailPage;
